<div class="layout-container" [ngClass]="containerClass">

    <app-topbar></app-topbar>
    <app-sidebar></app-sidebar>

    <div class="layout-content-wrapper">

        <!-- <main> qui e non su .layout-content-wrapper: il footer e' fratello di
             questo blocco, e se finisse dentro <main> smetterebbe di valere come
             contentinfo. -->
        <main class="layout-content">
            <router-outlet></router-outlet>
        </main>

        <app-footer></app-footer>
    </div>
  <!--  <app-config></app-config> -->

    <div *ngIf="layoutService.state.staticMenuMobileActive" class="layout-mask"></div>
</div>
